
export const P03_01 = {
    "selectedValueColumn": "CustomerGroup",
    "selectedTitle": "Customer",
    "visual": [
        {
            "columns": 12,
            "rows": 3,
            "visual": {
                "id": 13,
                "type": "advancedTable",
                "colorTheme": "colorTheme1",
                "title": "Customer Sales Summary",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Customer Code',
                                "columnName": 'CustomerCode',
                                "width": '160px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Customer Name',
                                "columnName": 'CustomerName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Net Sales',
                                "columnName": 'ActualSales',
                                "width": '160px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY Net Sales',
                                "columnName": 'LYSales',
                                "width": '180px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            },
                            {
                                "name": 'YTD Net Sales',
                                "columnName": 'YTDActualSales',
                                "width": '150px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY YTD Net Sales',
                                "columnName": 'YTDLYSales',
                                "width": '170px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'YTDGrowth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": "CustomerName",
                        "endpoint": "P03.1",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "ConfigTypeCode", "value": "" },
                            { "key": "DistributorCode", "value": "" },
                            { "key": "CustomerGroup", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        }
    ],
}